
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
// joel dashboard
import DashboardContent from '../../Dashboard/DashboardContent/dashboardcontent';


const AdminHome = () => {
    return (
        <div>
            <DashboardContent/>
        </div>
    );
};

export default AdminHome;
